import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";
import { ArrowRight } from "lucide-react";

function Card({ item }) {
  return (
    <div className="luxury-blog-card">
      <Link to={`/blog/${item?.slug}`} className="blog-card-anchor">
        
        {/* IMAGE & BADGE CONTROLLER CONTAINER */}
        <div className="blog-media-container position-relative overflow-hidden">
          <img 
            src={item?.image || "https://theorangeapes.com/frontend/img/blog-placeholder.jpg"} 
            alt={item?.title || "Blog Story"} 
            loading="lazy" 
            className="blog-main-media-img" 
          />
          
          {item?.date && (
            <div className="luxury-blog-date-badge">
              {getDateAgo(item?.date)}
            </div>
          )}
        </div>

        {/* 🌟 OVERLAPPING INFO CONTAINER BLOCK */}
        <div className="blog-overlapping-content-box">
          <h4 className="luxury-blog-title">{item?.title}</h4>
          <p className="luxury-blog-desc">{item?.shortDescription}</p>

          <div className="luxury-blog-footer-link pt-3">
            <span className="blog-read-story-trigger">
              Read Story <ArrowRight size={15} className="ms-2 arrow-motion-icon" />
            </span>
          </div>
        </div>

      </Link>
    </div>
  );
}

export default Card;